import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Directive, Input, OnChanges, Renderer2 } from '@angular/core';
import { MatBadge } from '@angular/material/badge';

@Directive({
  selector: '[matBadgeIcon]'
})
export class MatBadgeIconDirective implements OnChanges {

	private isMatBadgeIcon: boolean = true;

	@Input()
	get matBadgeIcon () { return this.isMatBadgeIcon; }
	set matBadgeIcon(value: any) { this.isMatBadgeIcon = coerceBooleanProperty(value); }

  	constructor(private matBadge: MatBadge,
				private renderer: Renderer2) { }

	ngOnChanges(): void {

		let fontSize: string = '18px';

		switch(this.matBadge.size) {
			case 'small': fontSize = '16px'; break;
			case 'medium': fontSize = '18px'; break;
			case 'large': fontSize = '28px'; break;
		}

		const badgeElement: HTMLElement = this.matBadge?.getBadgeElement();

		if(this.isMatBadgeIcon === true && badgeElement) {
			this.renderer.setStyle(badgeElement, 'font-family', 'Material Symbols Rounded');
			this.renderer.setStyle(badgeElement, 'font-size', fontSize);
		} else if(badgeElement) {
			this.renderer.removeStyle(badgeElement, 'font-family');
			this.renderer.removeStyle(badgeElement, 'font-size');
		}
	}
}
